function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "26",
  height: "25",
  viewBox: "0 0 26 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12.99 14.992a1 1 0 100-2.002 1 1 0 000 2.002zM7.986 15.992a1 1 0 100-2.001 1 1 0 000 2.001zM17.995 15.992a1 1 0 100-2.001 1 1 0 000 2.001z",
  fill: "#6B1BE3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.112 18.407l1.876-11.26a1.001 1.001 0 00-1.488-1.03l-6.04 3.452-3.556-7.994a1 1 0 00-1.827 0L8.522 9.582l-6.04-3.466A1 1 0 00.998 7.15l1.877 11.26A3.503 3.503 0 004.483 25h17.015a3.502 3.502 0 001.614-6.593zm-14.625-6.55a1.001 1.001 0 001.409-.461l3.095-6.951 3.09 6.95a1 1 0 001.413.461L22.666 8.9l-1.516 9.095H4.831L3.315 8.899l5.172 2.957zm13.01 11.141H4.484a1.501 1.501 0 010-3.002h17.015a1.501 1.501 0 010 3.002z",
  fill: "#6B1BE3"
})));